const TotalAlertCard = ({ alertCount, title }) => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-start w-100 bg-primary-shadow h-auto">
      <div className="ms-1" style={{ fontSize: 9.4 }}>
        {title}
      </div>
      <div className="d-flex align-items-center justify-content-between ms-1">
        <div className="d-flex align-items-center">
          <div style={{ fontSize: 14.1 }}>{alertCount}</div>
        </div>
      </div>
    </div>
  );
};

export default TotalAlertCard;
